// extracted by mini-css-extract-plugin
export default {"header":"header_header__fCG2X","header__contact":"header_header__contact__F+3Dt","header-contact":"header_header-contact__mXgs5","header__logo":"header_header__logo__DjPxh"};